import { useEffect, useRef, useState } from 'react'
import { cn } from '../utils/cn'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './Tooltip'

export const OverflownText = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) => {
  const ref = useRef(null)
  const [isOverflown, setIsOverflown] = useState(false)
  useEffect(() => {
    const element: HTMLDivElement = ref.current!
    setIsOverflown(element.scrollWidth > element.clientWidth)
  }, [])

  const content = (
    <div
      suppressHydrationWarning={true}
      className={cn('max-w-36 truncate relative', className)}
      ref={ref}
    >
      {children}
    </div>
  )

  if (isOverflown)
    return (
      <TooltipProvider delayDuration={200}>
        <Tooltip>
          <TooltipTrigger className='w-full'>{content}</TooltipTrigger>
          <TooltipContent>
            <p suppressHydrationWarning={true}>{children}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    )

  return content
}
